import { PlusOutlined } from "@ant-design/icons"
import { Card, Flex, Typography } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

const { Text } = Typography

interface CreateFolderCardProps {
  onClick?: () => void
}

// The Folders grid's counterpart to Albums' CreateAlbumCard — same "dashed
// tile is the create entry point" pattern, sized to match FolderCard's
// compact row instead of Album's taller square tile.
export function CreateFolderCard({ onClick }: CreateFolderCardProps) {
  const { t } = useTranslation()

  return (
    <Card hoverable size="small" onClick={onClick} className="border-dashed cursor-pointer">
      <Flex align="center" gap="small">
        <div className="size-8 rounded-full bg-primary/10 flex items-center justify-center shrink-0">
          <PlusOutlined className="text-primary" />
        </div>
        <Text strong className="text-sm">
          {t("files.folder.createCard.title")}
        </Text>
      </Flex>
    </Card>
  )
}
